import api from './api';

/**
 * Conti prodotto per medico.
 *
 * Le letture sono aperte a chiunque abbia un account, ma il server
 * restringe: un medico riceve soltanto le proprie righe, e chi non ha un
 * medico collegato riceve 403. Non c'e' niente da filtrare qui.
 *
 * Le scritture sono riservate ad admin e segreteria.
 */
export const contiMediciAPI = {
    elenco: (params) => api.get('/conti-medici', { params }),
    perLotto: (lottoId) => api.get(`/conti-medici/lotto/${lottoId}`),
    movimenti: (params) => api.get('/conti-medici/movimenti', { params }),

    assegna: (lotto_id, righe, note) =>
        api.post('/conti-medici/assegna', { lotto_id, righe, note }),
    travaso: (dati) => api.post('/conti-medici/travaso', dati),
    rettifica: (dati) => api.post('/conti-medici/rettifica', dati),
};

export default contiMediciAPI;
